import React from 'react';
import { Types } from '~/Api/DataSourceStatus';
import { formatHumanDate } from '~/DateTime';

interface Props {
	name: string;
	date: Date;
	validtype: string;
}

export const statusToAdverbForm = (validtype: string) => {
	switch (validtype) {
		case Types.upToDate:
			return 'UP TO DATE';
		case Types.processing:
			return 'PROCESSING';
		case Types.caution:
			return 'RECONSTRUCTION';
		default:
			return null;
	}
};

export default function CountryItemSource({ name, date, validtype }: Props) {
	return (
		<div className='py-2'>
			<div className='mb-1 flex justify-between items-start'>
				<h5 className='pr-2 inline-flex items-center text-md font-semibold text-cPurple-600'>{name}</h5>
				<span
					className={`px-1.5 py-1 font-display text-labelsmall leading-3 font-semibold text-white tracking-tight whitespace-nowrap ${
						validtype === 'up-to-date' ? 'bg-green-600' : 'bg-orange-600'
					}`}
				>
					{statusToAdverbForm(validtype)}
				</span>
			</div>
			<div className='flex justify-between text-labelmiddle font-normal'>
				<span className='text-gray-400'>Last update date:</span>
				<span className='text-gray-800 font-semibold'>{formatHumanDate(date)}</span>
			</div>
		</div>
	);
}
